import { LOGIN_METHOD_MAP } from './constants';
import type { LoginMethod, Method } from './types';

export function getMethod(loginMethod: LoginMethod): Method {
	return LOGIN_METHOD_MAP[loginMethod];
}
